import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/auth/auth-on-behalf/{personId}']['GET'];
type Input = ThisApi['params'];

const getAuthOnBehalf = async ({ personId }: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.get(`/auth/auth-on-behalf/${personId}`);
  return response.data;
};

export default getAuthOnBehalf;
